import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Link,
} from "@mui/material";
import { useEffect, useState } from "react";
import { get, put } from "src/utils/networkUtils";
import WinnerUserSearch from "./WinnerUserSearch";
import { generateWinnerEntries } from "src/utils/winnerEntries";
import useWithUrlTenant from "src/hooks/useTenant";

export default function SelectWinnerDialog({
  open,
  handleClose,
  data,
  prizeDrawId,
}) {
  const [entriesData, setEntriesData] = useState([]);
  const [prizeData, setPrizeData] = useState({});
  const [pickAgainData, setPickAgainData] = useState({});
  const [isInitial, setIsInitial] = useState(true);
  const [user, setUser] = useState(null);
  const withTenant = useWithUrlTenant();

  useEffect(() => {
    setPrizeData(data);
    setPickAgainData(data);
    if (data.userId) setIsInitial(false);
    get(withTenant(`/admin/prize-draws/${prizeDrawId}/entries`)).then(
      (response) => {
        setEntriesData(response.entries);
      }
    );
  }, [data, prizeDrawId, withTenant]);
  const pickRandom = () => {
    const winnerEntries = generateWinnerEntries(entriesData);
    const randomIndex = Math.floor(Math.random() * winnerEntries.length);
    const winner = winnerEntries[randomIndex];
    setPrizeData((prev) => ({
      ...prev,
      username: winner?.username,
      PrizeDrawEntryId: winner?.prizeDrawEntryId,
      winnerTicketNumber: winner?.winnerTicketNumber,
      userId: winner?.userId,
    }));
  };
  const handleUserIdsChange = (userData) => {
    setPrizeData((prev) => ({
      ...prev,
      username: userData.username,
      PrizeDrawEntryId: userData.prizeDrawEntryId,
      userId: userData.userId,
      winnerTicketNumber: userData.winnerTicketNumber,
    }));
    const user = userData ? { id: userData.userId } : null;
    setUser(user);
  };
  const handlePickAuto = async () => {
    const response = await put(
      `/admin/prize-draws/winner-auto-select/${prizeDrawId}/${prizeData.PrizeId}/${prizeData.userId}?initial=${isInitial}&ticketNumber=${prizeData.winnerTicketNumber}`,
      pickAgainData
    );
    if (response.success) {
      window.location.reload(true);
    }
  };
  const usersArray = user ? [user] : [];
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{ borderRadius: 3 }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" fontWeight="bold">
            Select a Winner
          </Typography>
          <Box display="flex" gap={2}>
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handlePickAuto}
              variant="contained"
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ borderRadius: 2, mt: 1, mb: 3 }}>
          {prizeData?.username ? (
            <Table>
              <TableHead
                sx={{
                  backgroundColor: "#f7f8f9",
                }}
              >
                <TableRow>
                  <TableCell>
                    <Typography fontWeight={600} color="text.secondary">
                      Prize
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography fontWeight={600} color="text.secondary">
                      Username
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography fontWeight={600} color="text.secondary">
                      Ticket
                    </Typography>
                  </TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{prizeData?.Title || ""}</TableCell>
                  <TableCell>
                    <Link
                      href="#"
                      underline="hover"
                      fontWeight="medium"
                      color="primary"
                    >
                      {prizeData?.username || ""}
                    </Link>
                  </TableCell>
                  <TableCell>{prizeData?.winnerTicketNumber || ""}</TableCell>
                  <TableCell align="right">
                    <Button
                      onClick={() => {
                        pickRandom();
                        setIsInitial(false);
                      }}
                      variant="outlined"
                      size="small"
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        px: 2,
                        py: 0.5,
                      }}
                    >
                      Pick Again
                    </Button>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          ) : (
            <TableCell align="right">
              <Button
                onClick={pickRandom}
                variant="outlined"
                size="small"
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  px: 2,
                  py: 0.5,
                }}
              >
                Pick Auto
              </Button>
            </TableCell>
          )}
        </Box>

        {/* Manual Select Section */}
        <Box
          sx={{
            backgroundColor: "#f7f8f9",
            borderRadius: 2,
            p: 2,
            mb: 2,
          }}
        >
          <Typography fontWeight={600}>Or Manually Select</Typography>
        </Box>

        <WinnerUserSearch
          onUserSelect={handleUserIdsChange}
          users={usersArray}
          prizeDrawId={prizeDrawId}
        />
      </DialogContent>
    </Dialog>
  );
}
